<template>
  <div>
    <v-layout class="p-4 pr-0 border-bottom-light-grey min-height-57px">
      <v-flex class="d-flex font-level-3-bold my-auto">
        <span class="detail-svg-icon mr-2">
          <!--begin::Svg Icon-->
          <!--  <v-icon color="blue darken-4">mdi-cart</v-icon> -->
          <span class="svg-icon svg-icon-lg mr-2 svg-v-list-icon">
            <!--end::Svg Icon-->
          </span>
        </span>
        <span class="form-title font-size-20 font-weight-700"
          >Demerit Points</span
        >
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn
        depressed
        @click="demeritDialog = true"
        color="cyan white--text"
        dense
        tile
        class="text-capitalize"
        >
        <v-icon left>mdi-plus</v-icon>
        CREATE
         </v-btn
      >
    </v-layout>

    <div
      class="overflow-y"
      style="max-height: calc(100vh - 306px)"
      v-if="!pageLoading"
    >
      <template v-if="demeritList.length">
        <table width="100%" class="detail-table table-head-sticky">
          <thead>
            <tr style="background-color: #f3f6f9; color: #24326d">
              <th
                width="50"
                class="py-1 font-size-14 text-uppercase font-weight-500"
              >
                #
              </th>

              <th class="py-1 font-size-14 text-uppercase font-weight-500">
                Date
              </th>
              <th class="py-1 font-size-14 text-uppercase font-weight-500">
                Violation type
              </th>
              <th class="py-1 font-size-14 text-uppercase font-weight-500">
                Description
              </th>
              <th class="py-1 font-size-14 text-uppercase font-weight-500">
                Demerit Points
              </th>
              <th class="py-1 font-size-14 text-uppercase font-weight-500">
                Issued by

              </th>
              <th class="py-1 font-size-14 text-uppercase font-weight-500">
               Actions

              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in demeritList"
              :key="index"
              :class="{
                'custom-border-top': index == 0,
                'orange_lighten-5': index % 2 == 0,
              }"
            >
              <template v-if="row?.id">
                <td class="p-2 border-top-light-grey">
                  {{ index + 1 }}
                </td>

                 <td class="p-2 border-top-light-grey">
                  <template v-if="row.added_at">
                    {{ formatDate(row.added_at) }}
                  </template>
                  <em v-else class="text-muted">no date</em>
                </td>

                <td class="p-2 border-top-light-grey">
                  <template v-if="row.violation_type">
                    {{ row.violation_type }}
                  </template>
                  <em v-else class="text-muted">no violation</em>
                </td>

                <td class="p-2 border-top-light-grey">
                  <template v-if="row.description">
                    {{ row.description }}
                  </template>
                  <em v-else class="text-muted">no description</em>
                </td>

                <td class="p-2 border-top-light-grey">
                  <template v-if="row.demerit_points">

                    <v-chip
                      color= "cyan"
                      text-color="white"
                      small
                      class="ml-2"
                      >
                     {{ Number(row.demerit_points) % 1 === 0 ? Number(row.demerit_points).toFixed(0) : Number(row.demerit_points) }}
                    </v-chip>
                  </template>
                  <em v-else class="text-muted">no demerit points</em>
                </td>

                <td class="p-2 border-top-light-grey">
                  <template v-if="row.issued_by">
                    {{ row.issued_by }}
                  </template>
                  <em v-else class="text-muted">no issued by</em>
                </td>

                <td class="p-2 border-top-light-grey">
                  <v-btn
                    class="mx-2 custom-bold-button white--text"
                    color="#24326d"
                    @click="onEdit(row)"
                    >
                    <v-icon left>mdi mdi-pencil</v-icon>
                    </v-btn>

                  <v-btn
                    class="mx-2 custom-bold-button white--text"
                    color="red"
                    @click="openDeleteDialog(row)"
                    >
                    <v-icon left>mdi mdi-delete</v-icon>
                </v-btn>  

                </td>

              </template>
            </tr>
           
             
          </tbody>
          <tfoot> <tr style="font-weight: bold;">
                <td class="pt-3" colspan="5"></td> 
                <td class="pt-3">Total Demerit Points</td>
                <td class="pt-3">{{demeritPoints}} Points</td>
               </tr>
            </tfoot>
        </table>
      </template>
      <p v-else class="m-0 row-not-found text-center">
        <img
          width="40px"
          :src="$assetURL('media/error/empty.png')"
          class="row-not-found-image"
        />
        Uhh... There are no demerit points at the moment.
      </p>
    </div>
    <div v-else class="mx-20 my-40 text-center">
      <v-progress-linear
        color="orange darken-2"
        indeterminate
        height="6"
      ></v-progress-linear>
    </div>
  
   <template v-if="demeritDialog">
        <CreateUpdateDemeritPoint
        :driver-id = driver
        :demerit-dialog="demeritDialog"
        v-on:close="closeDialog()"
        v-on:success="getData()"
        :edit-item="editItem"
        :do-update="!!editItem"
        ></CreateUpdateDemeritPoint>
    </template>


     <DeleteConfirmTemplate :delete-dialog="deleteConfirm">
      <template v-slot:title>Delete Confirmation</template>
      <template v-slot:text>
        <h3 class="font-size-16 font-weight-500 delete-text">
          Once you delete Demerit Point issued by
          <span class="font-weight-700">{{ removeItem?.issued_by }}</span>
            <template v-if="removeItem?.added_at">
              , added at <span class="font-weight-700">{{ formatDate(removeItem.added_at) }}</span>
            </template>
          , you won't be able to retrieve this later.<br />Are you sure you
          want to delete ?
        </h3>
      </template>
      <template v-slot:action>
        <v-btn

          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="deleteConfirm = false"
          >No! Cancel</v-btn
        >

        <v-btn
          :disabled="pageLoading"
          :loading="pageLoading"
          color="red lighten-1 white--text"
          v-on:click="deleteDemeritPoint()"
          class="mx-2 custom-grey-border custom-bold-button"
          >Yes! Delete</v-btn
        >
      </template>
    </DeleteConfirmTemplate>


  </div>

     

</template>
 
<script>
import { mapGetters } from "vuex";
import DeleteConfirmTemplate from "@/view/pages/partials/Delete";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CreateUpdateDemeritPoint from "@/view/pages/engineer/Create-Demerit-Points.vue";
import { GET , DELETE } from "@/core/services/store/request.module";

export default {
  name: "driverDemritPoints",
  mixins: [CommonMixin, ValidationMixin],
  props: {
    
    typeUuid: {
      type: String,
      default: null,
    },

    driver : {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      formValid: true,
      demeritList: [],
      pageLoading: false,
      demeritDialog: false,
      deleteConfirm: false,
      editItem : null,
      removeItem : null,
      
    };
  },
  watch: {
    driver: {
      handler(driver) {
        if (driver) {
          this.getDriverDemeritPoints();
        }
      },
      immediate: true,
      deep: true,
    },
  },
 
  methods: {


     openDeleteDialog(row) {
      this.removeItem = row;
      this.deleteConfirm = true;
    },

     onEdit(item) {

        this.editItem = { ...item }; 
       
        this.demeritDialog = true;
        },

      deleteDemeritPoint() {
         this.pageLoading = true;
         const requestUrl = `engineer/${this.driver}/demerit-point/${this.removeItem?.id}`;
         this.$store
        .dispatch(DELETE, { url: requestUrl })
        .then(() => {
          this.getDriverDemeritPoints();
          this.deleteConfirm = false;
          this.closeDialog();
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.pageLoading = false;
        });
      },

    closeDialog()
      {
        this.demeritDialog = false;
        this.editItem = null;  
      },

     

    getDriverDemeritPoints() {
       
      this.pageLoading = true; 
      this.$store
        .dispatch(GET, {
          url: `demerit-points/${this.driver}`,
        })
        .then((response) => {
          this.demeritList = response?.data;
        })
        .catch(() => {
          this.goBack();
        })
        .finally(() => {
           this.pageLoading = false; 
        });
    },

    getData()
    {
        this.demeritDialog = false;
        this.getDriverDemeritPoints();  
    }   

  },
  computed: {
    ...mapGetters(["errors"]),
    demeritPoints() {
    return this.demeritList.reduce((sum, row) => {
      return sum + (parseFloat(row.demerit_points) || 0);
    }, 0);
  }
  },
  components: {
    CreateUpdateDemeritPoint,
    DeleteConfirmTemplate
  },
  mounted() {
    this.getDriverDemeritPoints();
  },
};
</script>
